import React, { useState, SetStateAction, Dispatch, useEffect, useRef } from 'react';
import { strings } from 'src/localization';
import * as css from './ManuRecalls.module.scss';
import SVPButton from '../../SVPButtons/SVPButton';
import AdditionalService from '../../AdditionalServices/AdditionalService/containers/AdditionalService';
import { CustMode } from 'src/enums';
import { RecallData, VehicleRec, ascCtaInteractionInput, ascElementConfigurationInput } from 'src/models';
import { ascCtaInteraction, ascElementConfiguration } from 'src/helpers/EventHelper/EventHelper';

export interface IPropState {
    model: string,
    make: string,
    year: string,
    custMode: CustMode,
    vin: string,
    recallData: RecallData,
    theme: string,
    vehicles: VehicleRec[],
    selectedVehicle?: string,
}

const ManuRecalls = (props: IPropState) => {
    const [showRecalls, getRecalls] = useState(false);
    const [inqryRtn, setInqryRtn] = useState({ invoked: false, returned: false });
    const [, setRecallLength]:
        [undefined | number, Dispatch<SetStateAction<number | undefined>>] = useState();
    const recallMsgRef = useRef<HTMLDivElement>(null);
    const checkRecalls = (e: any) => {
        getRecalls(true);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'search',
            elementText: strings.CheckRecalls,
            elementColor: '',
            elementOrder: '',
            elementType: 'search_tool',
            elementSubType: 'other_buttons',
            eventAction: 'click',
            eventActionResult: 'search',
            linkUrl: '',
        };

        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: strings.CheckRecalls,
            elementType: 'search_tool',
            elementColor: '',
            eventAction: 'click',
            eventActionResult: 'search',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, e, props.vehicles, props.selectedVehicle);
    };
    const noArrow = props.theme === 'porsche' || props.theme === 'bmw' ? true : false;
    let recallMsg = `${strings.CheckRcl}`;

    // Upon selecting a new vehicle we need to reset the recallLength so that recalls will be checked again
    // useEffect(() => {
    //     setRecallLength(undefined);
    // }, [props.vin]);

    let recallOutput = (
        <div
            className={css.recallBtn}
        >
            <SVPButton
                id='chkRecalls'
                variant='secondaryBtnAlt'
                message={strings.CheckRecalls}
                handler={checkRecalls}
                tooltip={strings.ManuRecallTip}
                theme={props.theme}
                noArrow={noArrow}
            />
        </div>
    );
    if (showRecalls) {
        recallMsg = `${props.make} ${strings.InitiatedRcl} ${props.year} ` +
            `${props.model ?? props.make}. ${strings.AddToAppt}`;

        if (props.recallData.inquiryReturned) {
            recallOutput = (
                <div className={css.addtnlSvcBrdr}>
                    <div className={css.addtnlSvc}>
                        <AdditionalService
                            type='Recall'
                            vehLayoutCard
                            inqryRtnState={setInqryRtn}
                            setRecallLength={setRecallLength}
                        ></AdditionalService>
                    </div>
                </div>
            );
        } else {
            recallOutput = (
                <AdditionalService
                    type='Recall'
                    vehLayoutCard
                    inqryRtnState={setInqryRtn}
                    setRecallLength={setRecallLength}
                ></AdditionalService>
            );
        }

        if (props.recallData.inquiryError) {
            recallMsg = strings.InquiryError;
            recallOutput=(<AdditionalService
                type='Recall'
                vehLayoutCard
                inqryRtnState={setInqryRtn}
                setRecallLength={setRecallLength}
            ></AdditionalService>);
        }

        if (props.recallData.recalls?.length === 0 && !props.recallData.inquiryError && props.recallData.inquiryReturned) {
            recallMsg = `${strings.NoOustanding} ${props.year} ${props.model ?? props.make}.`;
            recallOutput = (
                <div id='noRecalls' className={css.noRecallBrdr}>
                    <div className={css.noRecall}>
                        <h4 className={css.noRecallRow}>{strings.zeroNumb}</h4>
                        <div className={css.noRecallRow}>{strings.outStandingRcl}</div>
                    </div>
                    <AdditionalService
                        type='Recall'
                        vehLayoutCard
                        inqryRtnState={setInqryRtn}
                        setRecallLength={setRecallLength}
                    ></AdditionalService>
                </div>
            );
        }
    }

    if (inqryRtn.invoked && !props.recallData.inquiryReturned && !props.recallData.inquiryError) {
        recallMsg = strings.PullingRecalls;
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            if (recallMsgRef.current && props.custMode === CustMode.CheckRecalls) {
                recallMsgRef.current.scrollIntoView({behavior: 'smooth'});
                getRecalls(true);
            }
        }, 500);

        return () => {
            clearTimeout(timer);
        };
    }, [props.custMode]);

    let summaryTitleCSS = css.summaryTitle;
    if (props.theme === 'buick') {
        summaryTitleCSS = css.summaryTitleBuick;
    }
    if (props.theme === 'dodge') {
        summaryTitleCSS = css.summaryTitleDodge;
    }
    if (props.theme === 'bmw') {
        summaryTitleCSS = css.summaryTitleBMW;
    }
    if (props.theme === 'ford') {
        summaryTitleCSS = css.summaryTitleFord;
    }

    const recallMsgCSS = props.theme === 'bmw' ? css.recallMsgBMW : null;

    return (
        <div>
            <hr className={css.topHr} />
            <h4 className={summaryTitleCSS}>{strings.ManuRecalls}</h4>
            <div id='recallMsg' className={recallMsgCSS} ref={recallMsgRef}>
                {recallMsg}
            </div>
            {recallOutput}
        </div>
    );
};

export default ManuRecalls;